export const MIN_PROMPT_LEN = 10;
export const MAX_PROMPT_LEN = 1000;

/** i18n keys — resolved via useTranslation at the call site. */
export const PROMPT_SUGGESTION_KEYS: string[] = [
  'promptSuggestions.0',
  'promptSuggestions.1',
  'promptSuggestions.2',
  'promptSuggestions.3',
  'promptSuggestions.4',
  'promptSuggestions.5',
  'promptSuggestions.6',
  'promptSuggestions.7',
];
